export default "__VITE_ASSET__Bz_O3fu9__"